exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.label-input .ant-input {\n  margin-bottom: 2px; }\n\n.ant-input-group-wrapper {\n  display: block; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/form/PasswordInput/style.scss
// module id = 1048
// module chunks = 0